import { Grid, Stack } from "@mui/material";
import TopSection from "../../Components/Common/Top/TopSection";
import ReminderForm from "./ReminderForm";

const ReminderNotification = () => {
  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/reminder-notification" },
                { title: "Dashboard" },
              ]}
              title="Reminder Notification"
            />
            <div>
              <ReminderForm />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default ReminderNotification
